import axios from "../../../axios";

const api = {
  getDownstreamTransportationAndDistributionItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/${params.questionnaireId}/downstream-transportation-distribution/items`,
      config).then(({ data }) => data);
  },

  addDownstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/downstream-transportation-distribution/items`, data, headers)
      .then(({ data }) => data);
  },

  updateDownstreamTransportationAndDistributionItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/downstream-transportation-distribution/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteDownstreamTransportationAndDistributionItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/supplier-questionnaires/${questionnaireId}/downstream-transportation-distribution/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importDownstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/downstream-transportation-distribution/items/import`, data, headers).then(({ data }) => data);
  },

  getDownstreamTransportationAndDistributionPreviewData({ previewId, params }, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/preview/${previewId}/downstream-transportation-distribution/items`, config).then(({ data }) => data);
  },
};

export default api;